<template>
  <div class="main-import-userAccount">
    <el-row class="top20">
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item style="width: 80px;">
          <el-input
              v-model="searchForm.realName"
              placeholder="姓名"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 180px;">
          <el-input
              v-model="searchForm.idNumber"
              placeholder="证件号码"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 120px;">
          <el-select
            v-model="searchForm.examId"
            clearable
            :loading="loading"
            placeholder="参与考场"
          >
            <el-option
              v-for="item in importExamList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="dateTimeRanges" clearable type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchUsers" icon="el-icon-search"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-button
          v-permission="['importUserAccount:importUserAccount:export']"
          size="small"
                 :disabled="!tableData.length > 0"
                 @click="downloadAccountVisible">
        导出测评账号
      </el-button>
      <el-button
        v-permission="['importUserAccount:importUserAccount:resetPassword']"
        :disabled="!multipleTable || !multipleTable.length > 0"
        size="small"
        @click="resetUserAccountPassword"
      >
        重置密码
      </el-button>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        row-key="id"
        stripe
        style="width: 100%;overflow-y: auto"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :height="tableHeight"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="realName"
          label="姓名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="idNumber"
          label="证件号码"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="exams"
          label="参与考场"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="username"
          label="测评账号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="password"
          label="测评密码"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      @size-change="handleSizeChange"
      :page-sizes="[20, 100, 500]"
      align="center"
    >
    </el-pagination>
    <el-dialog
      title="生成测评账号"
      :visible.sync="createAccountVisible"
      destroy-on-close
      @close="closeDialog"
    >
      <el-form label-width="80px">
        <el-form-item label="测评项目">
          <el-select
            v-model="importForm.examIds"
            multiple
            placeholder="请选择项目"
          >
            <el-option
              v-for="item in importExamList"
              :key="item.id"
              :label="item.examName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="pdt15" size="small" label-width="80px">
        <el-form-item label=" ">
          <el-upload
            :disabled="!importForm.examIds"
            ref="fileUploader"
            class="avatar-uploader"
            :action="
              apiConfig.importUserAccount.api.produce.url.accountImport +
                '?projectIds=' +
                importForm.examIds.join()
            "
            :headers="headers"
            :multiple="false"
            :limit="1"
            :fileList="fileList"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :on-progress="handleProgress"
            :on-error="handleError"
            :on-success="uploaded"
            :before-upload="beforeAvatarUpload"
          >
            <el-tooltip
              slot="trigger"
              :disabled="importForm.examId"
              content="请选择项目"
              placement="left"
              effect="light"
            >
              <el-button size="small" type="primary"
                >上传测评用户模板
              </el-button>
            </el-tooltip>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="text" @click="downloadTemplate">
            下载导入模板
          </el-button>
        </el-form-item>
      </el-form>
      <el-form label-width="80px">
        <el-form-item label=" ">
          <el-button
            type="primary"
            :disabled="!importForm.examIds || !uploadSuccess"
            @click="createAccount"
          >
            生成并导出账号密码
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="测评账号信息重复，是否覆盖？"
      :visible.sync="dialogTableVisible"
    >
      <el-table :data="gridData">
        <el-table-column
          property="realName"
          label="姓名"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          property="idNumber"
          label="证件号码"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          property="mphone"
          label="手机号"
          width="200"
          align="center"
        ></el-table-column>
      </el-table>
      <el-button @click="cancelExistUserAccount">取消覆盖</el-button>
      <el-button type="primary" @click="doUploadExistUserAccount"
        >确认覆盖
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserPager,
  produceUserAccount,
  getExamList,
  exportUserAccount,
  exportAccountError,
  downloadUserAccount,
  doUploadExistUser
} from "@/api/importUserAccount";
import permission from "@/directive/permission"; // 权限判断指令
import { getProjecsId, searchProjectByAgentIds } from "@/api/projectInfo";
import { defaultPageConfig } from "@/config/pagination";
import { getToken, getAgentUserId, getAgentId } from "@/utils/auth";
import { apiConfig } from "@/config/api";
import { resetUserAccountPassword } from "@/api/userAssess";
import { getAgentChildAll } from "@/api/userInfo";
import { getAgentTree } from "@/api/agentInfo";
import selectTree from "@/components/selectTree";

export default {
  name: "ImportUserAccount",
  directives: { permission },
  components: {
    selectTree
  },
  data: function() {
    return {
      apiConfig: apiConfig,
      uploadSuccess: false,
      fileList: [],
      createAccountVisible: false,
      headers: {
        Authorization: getToken(),
        Authorizator: getAgentUserId(),
        Organization: getAgentId()
      },
      importForm: {
        examIds: []
      },
      importExamList: [],
      dateTimeRanges: [],
      searchForm: {
        realName: null,
        idNumber: null,
        examId: null,
        from: null,
        agentName: null,
        baseInfoAuditStatus: null,
        auditStatus: null,
        startDate: "",
        endDate: "",
        date: [],
        agentIds: []
      },
      allExamIds: [],
      multipleTable: [],
      gridData: [],
      dialogTableVisible: false,
      exportUserInfoForm: {
        idNumbers: []
      },
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      agentList: [],
      agentTreeData: [],
      tableHeight: 600
    };
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    }
  },
  watch: {
    dateTimeRanges(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0] + " 00:00:00";
        this.searchForm.endDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
      // console.log(this.searchForm.startDate)
    },
  },
  created() {
    let now = new Date();
    let startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
    this.dateTimeRanges = [this.$dayjs(startDate).format('YYYY-MM-DD'), this.$dayjs(now).format('YYYY-MM-DD')]
    this.searchForm.startDate = this.dateTimeRanges[0] + " 00:00:00";
    this.searchForm.endDate = this.dateTimeRanges[1] + " 23:59:59";
    this.getAgentChildAll();
    this.getAgentTree();
  },
  mounted() {
    this.getExams();
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
        document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    handleSizeChange() {
      this.loadUsers();
    },
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.loadUsers();
    },
    loadUsers() {
      getUserPager(this.searchForm, {
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.code === 200) {
          this.tableData = res.data.list || [];
          this.tablePages = Number(res.data.pages);
          this.tableTotal = Number(res.data.total);
        } else {
          this.tableData = [];
          this.tablePages = 0;
          this.tableTotal = 0;
        }
      });
      // this.getProjectsId();
    },
    beforeAvatarUpload(file) {
      let isExcel =
        file.type === "application/vnd.ms-excel" ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      let isLt500K = file.size / 1024 < 500;

      if (!isExcel) {
        this.$message.error("只能上传excel文件!");
      }
      if (!isLt500K) {
        this.$message.error("上传excel大小不能超过 500KB!");
      }
      return isExcel && isLt500K;
    },
    handleProgress: function() {
      this.loadingInstance = this.$loading({ lock: true, text: "正在上传..." });
    },
    handleError: function(error) {
      this.$message({
        message: error,
        type: "error"
      });
      this.loadingInstance.close();
    },
    uploaded: function(response) {
      if (response.code !== 200) {
        this.$confirm(response.message, "提示", {
          type: "error"
        });
        if (response.code === 9998) {
          exportAccountError({
            examIds: this.importForm.examIds.join()
          }).then(res => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          });
        }
      } else {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.uploadSuccess = true;
      }
      this.loadingInstance.close();
    },
    createAccount() {
      produceUserAccount({
        examIds: this.importForm.examIds.join(),
        accountCreateType: 1
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.gridData = res.data;
          this.dialogTableVisible = true;
        } else {
          this.doUploadExistUserAccount();
        }
      });
    },
    getExams() {
      getExamList().then(res => {
        if (res.code === 200) {
          this.importExamList = res.data;
        }
      });
    },
    closeDialog() {
      this.uploadSuccess = false;
      this.fileList = [];
      this.importForm.examIds = [];
    },
    downloadTemplate() {
      window.open("/template/导入测评账号模板.xlsx");
    },
    // getProjectsId(query) {
    //   let that = this;
    //   that.loading = true;
    //   getProjecsId(query)
    //     .then(res => {
    //       if (res && res.code === 200) {
    //         that.allExamIds = res.data;
    //       }
    //     })
    //     .finally(() => {
    //       that.loading = false;
    //     });
    // },
    searchUsers() {
      let form = this._.cloneDeep(this.searchForm);
      form.page = 1;
      form.pageSize = this.pageSize;
      getUserPager(form).then(res => {
        if (res && res.code === 200) {
          this.tableData = res.data.list;
          this.tablePages = Number(res.data.pages);
          this.tableTotal = Number(res.data.total);
        } else {
          this.tableData = [];
          this.tablePages = 0;
          this.tableTotal = 0;
        }
      });
      // this.getProjectsId();
    },
    downloadAccountVisible() {
      if (
        !this.exportUserInfoForm.idNumbers ||
        this.exportUserInfoForm.idNumbers.length <= 0
      ) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportUserInfoCall(true);
        });
      } else {
        this.exportUserInfoCall(false);
      }
    },
    exportUserInfoCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportUserInfoForm = this._.cloneDeep(this.exportUserInfoForm);
      if (flag) {
        this._.assign(exportUserInfoForm, searchForm);
      }
      downloadUserAccount(exportUserInfoForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          if (res.type && res.type.includes('application/json')) {
            let that = this;
            const reader = new FileReader();
            reader.onload = function (event) {
              const message = JSON.parse(reader.result).message;
              that.$message.error(message);
            }
            reader.readAsText(res);
            return
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    resetUserAccountPassword() {
      let userAccounts = (this.multipleTable = this.$refs.multipleTable.selection);
      if (userAccounts.length > 0) {
        this.$confirm("确定重置密码?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          resetUserAccountPassword(userAccounts)
            .then(res => {
              if (res && res.code === 200) {
                this.loadUsers();
                this.$message({
                  message: "密码重置成功",
                  type: "success"
                });
              }
            })
            .finally(() => {});
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleTable = [];
      val.filter(item => {
        this.multipleTable.push(Number(item.id));
      });
      this.exportUserInfoForm.idNumbers = val.map(item => {
        return item.idNumber;
      });
    },
    cancelExistUserAccount() {
      this.doUploadUserAccount(0);
      this.dialogTableVisible = false;
    },
    doUploadExistUserAccount() {
      this.doUploadUserAccount(1);
      this.dialogTableVisible = false;
    },
    doUploadUserAccount(flag) {
      doUploadExistUser({
        examIds: this.importForm.examIds.join(),
        accountCreateType: 1,
        flag: flag
      }).then(res => {
        if (res && res.code === 200) {
          this.loadUsers();
          this.$message({
            message: "用户信息导入成功",
            type: "success"
          });
        }
        exportUserAccount({
          examIds: this.importForm.examIds.join()
        }).then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        });
      });
    },
    getAgentChildAll() {
      getAgentChildAll().then(res => {
        if (res.code === 200 && res.data) {
          this.agentList = res.data;
          this.searchForm.agentIds.push(this.agentList[0].agentId);
          this.loadUsers();
        }
      });
    },
    searchProjectByAgentIds() {
      searchProjectByAgentIds(this.searchForm.agentIds).then(res => {
        if (res.code === 200 && res.data) {
          this.importExamList = res.data;
        }
      });
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.main-import-userAccount {
  .dashboard {
    &-container {
      margin: 30px;
    }

    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }

  .top20 {
    padding-bottom: 20px;
  }

  .el-select {
    width: 100%;
  }
  .search-form .el-form-item#myselfAgent .el-form-item__content {
    .el-select {
      width: 230px;
      .el-select__tags-text {
        display: inline-block;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .el-tag__close.el-icon-close {
        top: -6px;
      }
    }
  }
}
</style>
